module.exports = __webpack_public_path__ + "static/media/sebastian.0b972153.jpg";